import React from 'react';
import { Box, Typography, Grid, Button, Card, CardMedia, Fade } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';

const ExperiencesAndMaterials = () => {
  const { ref: expRef, inView: expInView } = useInView({ triggerOnce: true });
  const { ref: matRef, inView: matInView } = useInView({ triggerOnce: true });
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/gallery');
  };

  return (
    <Box sx={{ padding: '100px 0', backgroundColor: '#fff' }}>
      <Grid container spacing={12} alignItems="center">
        
        {/* Melamine Section */}
        <Grid item xs={12} md={6} sx={{ position: 'relative' }}>
          <Fade in={expInView} timeout={3000}>
            <Card
              ref={expRef}
              sx={{
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: 3,
              }}
            >
              <CardMedia
                component="img"
                image="/images/Melamine/Image_20241015222131.webp"
                alt="Melamine"
                sx={{ height: 400, objectFit: 'cover' }}
              />
            </Card>
          </Fade>
          <Box
            sx={{
              position: 'absolute',
              top: '30px',
              left: '30px',
              width: '90%',
              height: '90%',
              borderRadius: '20px',
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
              zIndex: 0,
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={{ paddingRight: '50px' }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 'bold',
                color: '#f97316',
                letterSpacing: '2px',
                marginBottom: '8px',
              }}
            >
              MELAMINE
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: 'bold', marginBottom: '20px', color: '#000' }}
            >
              Durable and Easy to Maintain
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: '#4B4B4B', marginBottom: '32px', lineHeight: 1.8 }}
            >
              Melamine is widely used for furniture surfaces due to its high durability 
              and resistance to wear and scratches, making it perfect for frequent use.
            </Typography>
            <Button
              variant="text"
              endIcon={<ArrowForwardIosIcon />}
              onClick={handleNavigate}
              sx={{ color: '#f97316', fontWeight: 'bold', padding: 0 }}
            >
              View More
            </Button>
          </Box>
        </Grid>

        {/* PET Section */}
        <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
          <Box sx={{ paddingLeft: '50px' }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 'bold',
                color: '#f97316',
                letterSpacing: '2px',
                marginBottom: '8px',
              }}
            >
              PET
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: 'bold', marginBottom: '20px', color: '#000' }}
            >
              Eco-friendly and Glossy Finish
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: '#4B4B4B', marginBottom: '32px', lineHeight: 1.8 }}
            >
              PET is known for its environmental benefits and high gloss, giving furniture a 
              modern and sleek look, perfect for contemporary designs.
            </Typography>
            <Button
              variant="text"
              endIcon={<ArrowForwardIosIcon />}
              onClick={handleNavigate}
              sx={{ color: '#f97316', fontWeight: 'bold', padding: 0 }}
            >
              View More
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 }, position: 'relative' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Fade in={matInView} timeout={1000}>
                <Card
                  ref={matRef}
                  sx={{
                    borderRadius: '20px',
                    overflow: 'hidden',
                    boxShadow: 3,
                  }}
                >
                  <CardMedia
                    component="img"
                    image="/images/PET/Image_20241015231116.webp"
                    alt="PET"
                    sx={{ height: 180, objectFit: 'cover' }}
                  />
                </Card>
              </Fade>
            </Grid>
            <Grid item xs={6}>
            <Fade in={matInView} timeout={3000}>
              <Card
                sx={{
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: 3,
                }}
              >
                <CardMedia
                  component="img"
                  image="/images/Thermofoil/Image_20241015231009.webp"
                  alt="Thermofoil"
                  sx={{ height: 180, objectFit: 'cover' }}
                />
              </Card>
              </Fade>
            </Grid>
            <Grid item xs={12}>
            <Fade in={matInView} timeout={6000}>
              <Card
                sx={{
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: 3,
                }}
              >
                <CardMedia
                  component="img"
                  image="/images/Thermofoil/Image_20241015231022.webp"
                  alt="Thermofoil"
                  sx={{ height: 180, objectFit: 'cover' }}
                />
              </Card>
              </Fade>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ExperiencesAndMaterials;